import ReturnContent from "@/pages/(app)/returns/view/components/return-content/return-content";
import { useGetReturnRequestSuspense } from "@babackapp/private-api-client/client/use-get-return-request";
import { useParams } from "react-router-dom";
import { CurrentReturnRequestProvider } from "../utils/current-return-request-context";
import { LineItemsLoadingStateProvider } from "../utils/line-items-loading-state-context";

export default function ReturnPage() {
  const { returnId, shopId } = useParams<{
    returnId: string;
    shopId: string;
  }>();
  const { data: returnRequest } = useGetReturnRequestSuspense({
    shopId: shopId!,
    returnRequestId: returnId!,
  });

  /**
   * I could have done a single provider for lineItemsState and lineItemsLoadingState...
   * But I wanted to keep the logic separated... It would be easy to
   * merge them if needed.
   */

  return (
    <CurrentReturnRequestProvider returnRequest={returnRequest}>
      <LineItemsLoadingStateProvider>
        <ReturnContent />
      </LineItemsLoadingStateProvider>
    </CurrentReturnRequestProvider>
  );
}
